import axios from "axios";
import router from "../router";
const ls = require("local-storage");

const _axios = axios.create({
  // baseURL: processnv.env.BASE_URL
  // baseURL: "http://localhost:3000/api",
  // baseURL: 'http://192.168.0.135:3005/api',
  // baseURL: 'http://192.168.1.220:3000/api'  // ALPEGA
  // baseURL: 'http://192.168.18.16:3000/api' // Ilha Verdade
  // baseURL: 'http://192.168.18.15:3000/api' // Ilha Verdade ---- COMPEXO ESCOLAR
  // baseURL: 'http://10.112.0.20:3000/api' //  BENDIZER LOCAL
  // baseURL: 'http://102.130.194.27:3005/api' //**********************************IP PÚBLICO BENDIZER */
  // baseURL: 'http://192.168.1.254:3000/api' // ESCA
  // baseURL:  process.env.VUE_APP_ROOT_API // vai obter a base url de forma automática
  // baseURL: 'https://10.0.2.2:3000/api' // MOBILE
  // baseURL: 'https://api.bendizer.net/api' // Bendizer
  // baseURL: 'https://restrito.softlineangola.com/api' // Base Nuvem IMS MAIANGA/ === Que esta em uso
  // baseURL: 'https://saas.softlineangola.com/api' // Base Nuvem DO  KALAWENDA/ === Que esta em uso
  // baseURL: 'https://server.softlineangola.com/api' // Base Nuvem DO  KALAWENDA/ === Que esta em uso
   baseURL: 'https://restritokw.softlineangola.com/api'
})
  // Add a request interceptor*
_axios.interceptors.request.use(function (config) {
  try {
    const token = ls.get("token");
    const role = ls.get("role");
    const idInstituicao = ls.get("i_id");
    const anolectivo = ls.get("anolectivo");
    const idPessoa = ls.get("idPessoa");
    const nomeUsuario = ls.get("nomeUsuario");
    const username = ls.get("username");
    const instituicaodescricao = ls.get("instituicaodescricao");
    const idCursoCoordenador = ls.get("idCursoCoordenador");
    const pkUsuario = ls.get("pkUsuario");
    const ims = ls.get("ims");
    config.headers.Authorization = token
      ? `Bearer ${token} ${role} ${idInstituicao} ${anolectivo} ${idPessoa} ${nomeUsuario} ${username} ${instituicaodescricao} ${idCursoCoordenador} ${pkUsuario} ${ims}`
      : "";
    return config;
  } catch (err) {
    console.log("primeiro errooo ----> " + "" + err);
    return Promise.reject(err);
  }
});

_axios.interceptors.response.use(
  (response) => {
    // Do something with response data
    return response;
  },
  (error) => {
    // Do something with response error

    // You can even test for a response code
    // and try a new request before rejecting the promise
    try {
      if (error.response.status === 403 || error.response.status === 401) {
        ls.set("fatal", "Acesso negado");
        router.push("/");
      }
    } catch (err) {
      ls.set("fatal", "" + err + "b ->  " + error);
      console.log("verrr erro ----> " + "" + err + "b ->  " + error);
      // router.push('/')
    }

    return Promise.reject(error);
  }
);

/** */
export default _axios;
